/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { AslDTO } from '../model/aslDTO';
import { BASE_PATH } from '../variables';



@Injectable()
export class AslControllerService {

  protected basePath = 'https://fidcare.kiranet.it/api/cdr';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * View single asl by id
   *
   * @param uuid Id of the asl
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAslUsingGET(uuid: string, observe?: 'body', reportProgress?: boolean): Observable<AslDTO>;
  public getAslUsingGET(uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AslDTO>>;
  public getAslUsingGET(uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AslDTO>>;
  public getAslUsingGET(uuid: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (uuid === null || uuid === undefined) {
      throw new Error('Required parameter uuid was null or undefined when calling getAslUsingGET.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      '*/*'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<AslDTO>(`${this.basePath}/asls/${encodeURIComponent(String(uuid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * View Asl list by uuid city
   *
   * @param uuid UUID City
   * @param date date
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public loadAslByCityUsingGET(uuid: string, date?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<AslDTO>>;
  public loadAslByCityUsingGET(uuid: string, date?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AslDTO>>>;
  public loadAslByCityUsingGET(uuid: string, date?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AslDTO>>>;
  public loadAslByCityUsingGET(uuid: string, date?: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (uuid === null || uuid === undefined) {
      throw new Error('Required parameter uuid was null or undefined when calling loadAslByCityUsingGET.');
    }


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (date !== undefined && date !== null) {
      queryParameters = queryParameters.set('date', <any>date.toISOString());
    }
    if (uuid !== undefined && uuid !== null) {
      queryParameters = queryParameters.set('uuid', <any>uuid);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      '*/*'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<Array<AslDTO>>(`${this.basePath}/asls/city`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * View a list of asls filtered by start date and end date
   *
   * @param date Date for perform filtering. Date format &#39;yyyy-MM-dd&#39;.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public loadAslsUsingGET(date: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<AslDTO>>;
  public loadAslsUsingGET(date: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AslDTO>>>;
  public loadAslsUsingGET(date: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AslDTO>>>;
  public loadAslsUsingGET(date: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (date === null || date === undefined) {
      throw new Error('Required parameter date was null or undefined when calling loadAslsUsingGET.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (date !== undefined && date !== null) {
      queryParameters = queryParameters.set('date', <any>date.toISOString());
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      '*/*'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<Array<AslDTO>>(`${this.basePath}/asls`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
